'use client';

import { usePathname } from 'next/navigation';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ONBOARDING_STEPS } from '@/services/onboarding-state';

const STEP_LABELS = ['Identity', 'Landscape', 'Radar'];

function getStepIndex(pathname) {
  if (pathname?.includes('/identity')) return 0;
  if (pathname?.includes('/landscape')) return 1;
  if (pathname?.includes('/focus')) return 2;
  return 0;
}

export default function OnboardingProgress() {
  const pathname = usePathname();
  const currentIndex = getStepIndex(pathname);

  return (
    <div className="flex items-center justify-center gap-2 sm:gap-3">
      {STEP_LABELS.map((label, i) => {
        const isCompleted = i < currentIndex;
        const isCurrent = i === currentIndex;

        return (
          <div key={label} className="flex items-center gap-2 sm:gap-3">
            {/* Step circle */}
            <div className="flex flex-col items-center gap-1.5">
              <div
                className={cn(
                  'flex h-8 w-8 items-center justify-center rounded-full border-2 text-xs font-semibold transition-all duration-300',
                  isCompleted && 'border-primary bg-primary text-primary-foreground',
                  isCurrent && 'border-primary bg-primary/10 text-primary shadow-[0_0_12px_rgba(79,209,229,0.3)]',
                  !isCompleted && !isCurrent && 'border-border bg-background text-muted-foreground'
                )}
              >
                {isCompleted ? (
                  <Check className="h-4 w-4" />
                ) : (
                  i + 1
                )}
              </div>
              <span
                className={cn(
                  'hidden text-[10px] font-medium sm:block',
                  isCurrent ? 'text-foreground' : 'text-muted-foreground'
                )}
              >
                {label}
              </span>
            </div>

            {/* Connector line (not after last) */}
            {i < STEP_LABELS.length - 1 && (
              <div
                className={cn(
                  'h-0.5 w-8 sm:w-12 rounded-full transition-colors duration-300',
                  i < currentIndex ? 'bg-primary' : 'bg-border'
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
